
import {
	insertAfter
} from './../toolbox'

let formindex = 0

class SmartForm {
  constructor (el) {
    this.form = el
    this.form.id = `smartform-${formindex++}`
    this.form.setAttribute('novalidate', '')
    this.form.setAttribute('data-state', 'ready')
    this.show_response = this.form.hasAttribute('data-response')
    this.events = {
      validate: new CustomEvent('validate'),
      working: new CustomEvent('working'),
      error: new CustomEvent('error'),
      success: new CustomEvent('success'),
      done: new CustomEvent('done')
    }
    if (this.form.hasAttribute('data-api')) {
      this.form.addEventListener('submit', (e) => {
        this.submit(e)
      });
    }
    // console.log(this.form)
  }
  validate() {
    var valid = true;
    this.form.dispatchEvent(this.events.validate)
    Array.from(this.form.elements).forEach((elem) => {
      if (elem.getAttribute('data-state') === 'error') valid = false;
    })
    return valid;
  }
  submit(e) {
    e.preventDefault()
    e.stopPropagation()

    if (!this.validate()) return

    // get api url
    this.api = this.form.getAttribute('data-api')
  
    this.update('working')
    if (this.response_box) this.response_box.remove()
  
    if (this.api.length == 0 || this.api == 'test') {
      var testState = (this.form.hasAttribute('data-test-state')) ? this.form.getAttribute('data-test-state') : 'error'
      setTimeout(function () {
        this.update(testState)
      }.bind(this), 1000)
      return
    }
    this.sendData();
  }
  sendData() {
    const XHR = new XMLHttpRequest()
    const FD = new FormData(this.form)
    console.log(...FD)
    console.log(this.form)
    // Success
    XHR.addEventListener('load', (event) => {
      this.api_response = JSON.parse(event.target.responseText);
      if (event.target.status == 200) {
        this.update('success')
      } else {
        this.update('error')
      }
    });
    XHR.open("POST", this.api)
    XHR.send(FD)
  }
  update(state) {
    this.form.setAttribute('data-state', state);
    this.state = state;
    if (state == 'working') {
      this.form.dispatchEvent(this.events.working)
    }
    if (state == 'error') {
      this.form.dispatchEvent(this.events.error)
      this.response();
      requestAnimationFrame(() => {
        this.update('error-response');
      })
      setTimeout(function () {
        this.form.setAttribute('data-state', 'ready');
        if (this.response_box) this.response_box.remove();
      }.bind(this), 4000);
    }
    if (state == 'success') {
      this.form.dispatchEvent(this.events.success)
      setTimeout(function () {
        if (this.form.hasAttribute('data-redirect')) {
          window.location.pathname = this.form.getAttribute('data-redirect');
        }
        if (this.form.hasAttribute('data-collapse')) {
          this.form.classList.add('collapse');
        }
        this.response();
        requestAnimationFrame(() => {
          this.update('success-response');
        })
        setTimeout(function () {
          this.form.setAttribute('data-state', 'ready');
          if (this.response_box) this.response_box.remove();
          this.form.reset();
          this.form.dispatchEvent(this.events.done)
        }.bind(this), 5000);
      }.bind(this), 1000);
    }
  }
  response() {
    if (!this.show_response) return;
    if (this.api_response == undefined) {
      if (this.state == 'success') {
        this.api_response = {
          message: (this.form.hasAttribute('data-success-response')) ? this.form.getAttribute('data-success-response') : 'Success!'
        }
      }
      if (this.state == 'error') {
        this.api_response = {
          message: (this.form.hasAttribute('data-error-response')) ? this.form.getAttribute('data-error-response') : 'Error!'
        }
      }
  
    }
    this.response_box = document.createElement('div');
    this.response_box.classList.add('response-box');
    this.response_box.innerHTML = this.api_response.message;
    this.form.parentNode.insertBefore(this.response_box, this.form.nextSibling);
  }
}



function init () {
  Array.from(document.querySelectorAll('[data-smart-form]')).forEach(elem => {
    if(!elem.hasAttribute('data-state')) new SmartForm(elem)
  })
}
document.body.addEventListener('domupdated', () => init())
init()